<template>
	<div>
		<p class="credential-collaborate-heading">
			Invite users to collaborate on credential
			<b>{{ credential.name }}</b>
		</p>

		<el-divider class="compressedDivider"></el-divider>

		<el-autocomplete :fetch-suggestions="searchUsers" clearable placeholder="Search users by username"
			prefix-icon="el-icon-search" v-model="usersSearch" style="width: 100%;">
			<el-button slot="append" v-if="determineIfToShowAdd()" @click="addCollaborator"
				:loading="operationInProgress">
				Add
			</el-button>
		</el-autocomplete>

		<el-divider></el-divider>

		<el-container v-loading="operationInProgress">
			<el-main style="padding: 0px; max-height: 300px; overflow: auto">
				<ul class="credential-collaborators-title" v-if="collaborators.length">
					<li v-for="user in collaborators" :key="user.applicationUserID">
						<el-avatar>
							{{ user.username.charAt(0).toUpperCase() }}
						</el-avatar>

						<h4 style="margin-left: 15px">{{ user.username }}</h4>

						<el-tag style="margin-left: auto; margin-right: 15px" type="info">
							Can use only
						</el-tag>

						<el-button type="danger" icon="el-icon-delete" circle @click="removeCollaborator(user)"
							:loading="userRemovalInProgress === user.applicationUserID" />
					</li>
				</ul>

				<el-empty v-else description="No collaborators"></el-empty>
			</el-main>
		</el-container>

		<el-divider></el-divider>
	</div>
</template>

<script>
import Vue from "vue";

export default {
	props: {
		credential: Object,
	},
	data() {
		return {
			usersSearch: "",
			users: [],
			timeout: null,
			collaborators: [],
			operationInProgress: false,
			userRemovalInProgress: null,
		};
	},
	async mounted() {
		await this.fetchUsers();
		this.collaborators = this.credential.sharedWith || [];
	},
	watch: {
		credential: {
			immediate: true,
			handler(newVal) {
				this.collaborators = newVal?.sharedWith || [];
				this.usersSearch = "";
			},
		},
	},
	methods: {
		async fetchUsers() {
			const result = await this.httpHelper("RUNTIME", "GET", "security/fetchActiveUsers", {
				organisationName: Vue.$cookies.get("orgName"),
			});
			if (!result?.error) {
				this.users = result.response;
			}
		},

		searchUsers(queryString, cb) {
			if (!queryString) {
				cb([]);
				return;
			}
			const results = this.users.filter((each) =>
				each.username.toLowerCase().includes(queryString.toLowerCase())
			);
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				cb(results.map((each) => ({ value: each.username })));
			}, 300);
		},

		determineIfToShowAdd() {
			return (
				this.usersSearch &&
				this.users.find((u) => u.username === this.usersSearch)
			);
		},

		async addCollaborator() {
			const user = this.users.find((u) => u.username === this.usersSearch);
			if (!user) return;

			this.operationInProgress = true;

			const result = await this.httpHelper(
				"RUNTIME",
				"POST",
				"credentials/addCollaborativeUserToCredential",
				{
					credentialId: this.credential.id,
					userID: user.userID,
				}
			);

			this.operationInProgress = false;

			if (!result?.error) {
				this.collaborators.push(result.response);
				this.$notify({
					title: "Success",
					message: user.username + " added as collaborator",
					type: "success",
					position: "bottom-left",
				});
				this.usersSearch = "";
			} else {
				this.$notifyError(this, result.error);
			}
		},

		async removeCollaborator(user) {
			this.userRemovalInProgress = user.applicationUserID;

			const result = await this.httpHelper(
				"RUNTIME",
				"DELETE",
				"credentials/removeCollaborativeUserFromCredential",
				{
					credentialId: this.credential.id,
					userID: user.applicationUserID,
				}
			);

			this.userRemovalInProgress = null;

			if (!result?.error) {
				this.collaborators = this.collaborators.filter(
					(u) => u.applicationUserID !== user.applicationUserID
				);
				this.$notify({
					title: "Success",
					message: user.username + " removed",
					type: "success",
					position: "bottom-left",
				});
			} else {
				this.$notifyError(this, result.error);
			}
		},
	},
};
</script>

<style scoped>
li {
	list-style: none;
	display: flex;
	align-items: center;
	margin-bottom: 12px;
}

.credential-collaborate-heading {
	margin-top: -18px;
}

.credential-collaborators-title {
	margin: 0;
	margin-bottom: -12px;
	padding: 0;
}
</style>
